export enum UnitType {
	CoiledTubing = 1,
	Snubbing = 2,
	ChemMixing = 3,
	FluidPump = 4,
	NitrogenPump = 5,
	Peripheral = 6,
	FacilityTest = 7,
	ToePrep = 8,
	PumpDownWireline = 11,
	PumpDownAcid = 12,
}
